import { remove } from "lodash";

const initialState = {
  guides: []
};

const guidesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_GUIDES':
      return {
        ...state,
        guides: action.data.guides
      };
    case 'REMOVE_GUIDE': {
      const newGuidesList = remove(state.guides, (item) => item.guide_id !== action.data);
      return {
        ...state,
        guides: newGuidesList
      };
    }
    default:
      return state;
  }
};

export default guidesReducer;
